import { showUserAlert } from "../utils/userErrorMessage";
import React, { useState } from "react";
import { Input } from "../components/ui/input";
import Header from "../Component/Header"; // ✅ Header 가져오기
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { supabase } from "../supabase/client";
import { useNavigate } from "react-router-dom";
import { syncClientToFirstProfile } from "../utils/clientProfileSync";

const makeInternalUserId = (form) => {
  const emailPrefix = String(form.email || "").split("@")[0].trim();
  const phoneDigits = String(form.phone || "").replace(/\D/g, "");
  const name = String(form.name || "").trim();
  const base = emailPrefix || phoneDigits || name || "user";
  return `${base}-${Date.now()}`;
};

export default function UserAddForm() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    hire_date: "",
    password: "",
    system: "배차담당",
    branch: "",
    team: "",
    position: "",
    email: "",
    phone: "",
    address: "",
  });

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSubmit = async () => {
    const company = localStorage.getItem("email"); // ✅ 로그인한 회사 이메일
    const company_name = localStorage.getItem("companyName") || company;

    const payload = {
      ...form,
      user_id: makeInternalUserId(form),
      company,
      company_name,
    };
    const { data, error } = await supabase
      .from("client")
      .insert([payload])
      .select("*")
      .single(); // ✅ company 포함해서 insert
      
    if (error) {
      showUserAlert("등록 실패: " + error.message);
    } else {
      try {
        await syncClientToFirstProfile(data || payload, { company, companyName: company_name });
      } catch (profileError) {
        showUserAlert("client 등록은 완료됐지만 profiles 등록에 실패했습니다: " + profileError.message);
        return;
      }
      showUserAlert("사용자가 등록되었습니다.");
      navigate("/user-management");
    }
  };

  return (
    <div className="space-y-1">
      <Header />
      <div className="px-4 pt-1 pb-4 space-y-2">
      <h2 className="text-lg font-semibold">사용자 추가 등록</h2>
      <Card className="p-2">
        <CardContent className="bg-white">
          <div className="reservation-form-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="reservation-section-title">기본 정보</div>
            <div>
              <label className="block font-semibold mb-1">이름</label>
              <Input value={form.name} onChange={(e) => handleChange("name", e.target.value)} />
            </div>

            <div>
              <label className="block font-semibold mb-1">입사일</label>
              <Input
                type="date"
                value={form.hire_date}
                onChange={(e) => handleChange("hire_date", e.target.value)}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">비밀번호</label>
              <Input type="password" value={form.password} onChange={(e) => handleChange("password", e.target.value)} />
            </div>

            <div className="reservation-section-title">권한 및 소속</div>
            <div>
              <label className="block font-semibold mb-1">사용 시스템</label>
              <div className="flex gap-4">
                {["배차담당", "회계", "전체"].map((role) => (
                  <label key={role} className="flex items-center gap-1">
                    <input type="radio" name="system" value={role} checked={form.system === role} onChange={(e) => handleChange("system", e.target.value)} />
                    {role}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block font-semibold mb-1">지점명</label>
              <Input value={form.branch} onChange={(e) => handleChange("branch", e.target.value)} />
            </div>

            <div>
              <label className="block font-semibold mb-1">팀명</label>
              <Input value={form.team} onChange={(e) => handleChange("team", e.target.value)} />
            </div>

            <div>
              <label className="block font-semibold mb-1">직위명</label>
              <Input value={form.position} onChange={(e) => handleChange("position", e.target.value)} />
            </div>

            <div className="reservation-section-title">연락처</div>
            <div>
              <label className="block font-semibold mb-1">Email</label>
              <Input type="email" value={form.email} onChange={(e) => handleChange("email", e.target.value)} />
            </div>

            <div>
              <label className="block font-semibold mb-1">전화</label>
              <Input value={form.phone} onChange={(e) => handleChange("phone", e.target.value)} />
            </div>

            <div className="md:col-span-2 lg:col-span-3">
              <label className="block font-semibold mb-1">주소</label>
              <Input value={form.address} onChange={(e) => handleChange("address", e.target.value)} />
            </div>

            <div className="reservation-action-row">
              <Button onClick={handleSubmit}>등록</Button>
              <Button variant="outline" onClick={() => navigate("/user-management")}>돌아가기</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
    </div>
  );
}
